import { type AnalyticsManager } from "services/analytics/analyticsManager";
import type { AbnQuestionsStore } from "services/questions/au/abnQuestionsStore";
import { type CompanyAcnQuestionsStore } from "services/questions/au/companyAcnQuestionsStore";
import type { CompanyNameAcnQuestionsStore } from "services/questions/au/companyNameAcnQuestionStore";
import { type DirectorQuestionsStore } from "services/questions/au/directorQuestionsStore";
import { DirectorShareQuestionsStore } from "services/questions/au/directorShareQuestionsStore";
import type { IdentityQuestionsStore } from "services/questions/au/identityQuestionsStore";
import { RegisterFormStep } from "services/registerForm/registerFormStep";
import { RegisterFormSteps } from "services/registerForm/registerFormSteps";
import { RegisterFormStepsStoreBase } from "services/registerForm/registerFormStepsStoreBase";
import { AcnFormStep } from "./constants";

export class AcnRegisterFormStepsStore extends RegisterFormStepsStoreBase<AcnFormStep> {
  protected readonly _steps: RegisterFormSteps<AcnFormStep> = new RegisterFormSteps<AcnFormStep>([
    new RegisterFormStep(AcnFormStep.FLOW_SELECT, "Select the option"),
    new RegisterFormStep(AcnFormStep.CONSENT, "Before you get started"),
    new RegisterFormStep(AcnFormStep.COMPANY_NAME, "Company name", this._companyNameAcnQuestionStore),
    new RegisterFormStep(AcnFormStep.DIRECTOR, "Business associates", this._directorQuestionsStore),
    new RegisterFormStep(AcnFormStep.DIRECTOR_SHARE, "Shareholders", this._directorShareQuestionsStore),
    new RegisterFormStep(AcnFormStep.COMPANY, "Company details", this._companyQuestionsStore),
    new RegisterFormStep(AcnFormStep.ABN, "ABN details", this._abnQuestionsStore),
    new RegisterFormStep(AcnFormStep.IDENTITY, "Confirm identity", this._identityQuestionsStore),
    new RegisterFormStep(AcnFormStep.BASKET, "Your basket"),
    new RegisterFormStep(AcnFormStep.CONFIRM, "Confirm and submit"),
    new RegisterFormStep(AcnFormStep.CHARGE, "Confirm and submit"),
    new RegisterFormStep(AcnFormStep.COMPLETE, "Complete"),
  ]);
  readonly confirmStep: AcnFormStep = AcnFormStep.CONFIRM;
  readonly completeStep: AcnFormStep = AcnFormStep.COMPLETE;

  constructor(
    private readonly _companyQuestionsStore: CompanyAcnQuestionsStore,
    private readonly _abnQuestionsStore: AbnQuestionsStore,
    private readonly _directorQuestionsStore: DirectorQuestionsStore,
    private readonly _directorShareQuestionsStore: DirectorShareQuestionsStore,
    private readonly _identityQuestionsStore: IdentityQuestionsStore,
    protected readonly _analyticsManager: AnalyticsManager,
    protected readonly _companyNameAcnQuestionStore: CompanyNameAcnQuestionsStore,
  ) {
    super(_analyticsManager);
  }
}
